import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IWellKnownLinksSavePayload } from '../types';
import {
  WELL_KNOWN_DOMAINS_LIST_QUERY_KEY,
  WELL_KNOWN_LINKS_LIST_QUERY_KEY,
  WELL_KNOWN_LINKS_PERMISSIONS,
  WELL_KNOWN_LINKS_SAVE_API_URL,
  WELL_KNOWN_LINKS_SAVE_MUTATION_KEY,
} from '../constants';

export default function useSaveWellKnownLinksMutation(): IContextMutationResult<void, Error, IWellKnownLinksSavePayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IWellKnownLinksSavePayload>({
    mutationKey: [WELL_KNOWN_LINKS_SAVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      WELL_KNOWN_LINKS_SAVE_API_URL,
      payload,
      {
        permission: WELL_KNOWN_LINKS_PERMISSIONS.EDIT,
      },
    ),
    async onSuccess({ queryClient }) {
      void queryClient.invalidateQueries({ queryKey: [WELL_KNOWN_LINKS_LIST_QUERY_KEY] });
      await queryClient.invalidateQueries({ queryKey: [WELL_KNOWN_DOMAINS_LIST_QUERY_KEY] });
      displayPresetToast('created');
    },
  });
}
